import React from 'react';
import Link from 'gatsby-link';
import { Helmet } from 'react-helmet';

import HelmetSEO from '../components/seo';
import Components from '../components/components';
import { LinkDown } from '../components/link-back';
import { filterByLocation, stripNode } from '../helpers/get-contents';

const LocationPage = ({ data }) => {
    const page = data.page.edges[0].node;
    const traders = filterByLocation(
        stripNode(data.traders.edges),
        page.location
    );
    const insights = filterByLocation(
        stripNode(data.allInsights.edges),
        page.location
    );
    const locations = stripNode(data.locations.edges);
    const activelocations = stripNode(data.activelocations.edges);
    const regions = stripNode(data.regions.edges);
    const links = data.links.edges[0].node;
    const layoutmodules = data.layout.modules;

    let seo = {
        title: page.introTitle,
        description: page.intro,
        image: '',
    };
    layoutmodules.forEach(module => {
        if (module.__typename == 'DatoCmsMiniHero') {
            seo.image = module.image.sizes.src;
        }
    });
    return (
        <div>
            <HelmetSEO {...seo} />
            <LinkDown
                parent={{
                    slug: '#location-map',
                    pageName: 'map',
                }}
            />
            <div className="section indented-contents gray-dividers">
                <div className="mt-60" />
                <Components
                    content={{
                        __typename: 'LocationHeader',
                        ...page,
                    }}
                    locations={activelocations}
                />
                {layoutmodules.map((module, i) => (
                    <Components
                        key={i}
                        content={Object.assign(module, page)}
                        insights={insights}
                        locations={locations}
                        regions={regions}
                        traders={traders}
                    />
                ))}
            </div>
            <Components
                content={{
                    __typename: 'DatoCmsGiantLinkContainer',
                    links: [links],
                }}
            />
        </div>
    );
};

export default LocationPage;

export const LocationPageQuery = graphql`
    query InsightPageQusdasdfssdfsdfdsfdasdssfgfggfhgdfdfry($slug: String!) {
        page: allDatoCmsLocation(filter: { slug: { eq: $slug } }) {
            edges {
                node {
                    slug
                    location
                    region {
                        region
                    }
                    areasOfOperation {
                        location
                        services
                        isOffice
                        slug
                    }
                    areasOfOperationText
                    intro
                    introTitle
                    about
                    address
                    phone
                    phoneAvailability
                    fax
                    email
                    coordinates {
                        latitude
                        longitude
                    }
                    showOnMap
                    isOffice
                    images {
                        sizes(
                            maxWidth: 1100
                            imgixParams: { fm: "jpg", auto: "compress" }
                        ) {
                            base64
                            aspectRatio
                            src
                            srcSet
                            sizes
                        }
                    }
                }
            }
        }
        layout: datoCmsPageLocation {
            modules {
                __typename
                ... on DatoCmsLocationContactDetail {
                    title
                    body
                }
                ... on DatoCmsTradersOnLocation {
                    title
                    body
                }
                ... on DatoCmsAreaOfOperation {
                    title
                    body
                }
                ... on DatoCmsRelatedInsight {
                    id
                }
                ... on DatoCmsLocationImage {
                    id
                }
                ... on DatoCmsMapForLandingpage {
                    id
                }
            }
        }
        regions: allDatoCmsRegion(sort: { fields: [position], order: ASC }) {
            edges {
                node {
                    region
                    position
                }
            }
        }
        locations: allDatoCmsLocation(
            sort: { fields: [position], order: ASC }
        ) {
            edges {
                node {
                    ...LocationFragment
                }
            }
        }
        activelocations: allDatoCmsLocation(
            filter: { isOffice: { eq: true } }
            sort: { fields: [position], order: ASC }
        ) {
            edges {
                node {
                    ...LocationFragment
                }
            }
        }
        links: allDatoCmsGiantLink(limit: 1) {
            edges {
                node {
                    ...GiantLinkFragment
                }
            }
        }
        traders: allDatoCmsTrader(sort: { fields: [position], order: ASC }) {
            edges {
                node {
                    ...TraderFragment
                }
            }
        }
        allInsights: allDatoCmsInsightPage(
            sort: { fields: [date], order: DESC }
        ) {
            edges {
                node {
                    ...InsightCardFragment
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/templates/location-template.js